export default __webpack_public_path__ + "static/media/undraw_Alert_re_j2op 1.e43fd5b1.svg";